import { load, remove } from "@services/local-storage"
import axios from "axios"


const axiosClient = axios.create({
  baseURL: process.env.API_BASE_URL,
  withCredentials: true,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
})

// Request interceptor to add auth token
axiosClient.interceptors.request.use(
  (config) => {
    const token = load("token")
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// Response interceptor to handle 401 errors
axiosClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      // Opaque tokens are not refreshable; force re-login.
      remove("token")
      remove("user")
      if (typeof window !== "undefined") {
        window.location.assign("/login")
      }
    }
    return Promise.reject(error)
  }
)

export default axiosClient
